"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "22",
    viewBox: "0 0 24 22"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21,12H19.39a5.49,5.49,0,0,1-4.89,3H11v2a3,3,0,0,0,3,3h2.29l2.86,2.85A.49.49,0,0,0,20,22.5V20h1a3,3,0,0,0,3-3V15A3,3,0,0,0,21,12Z",
    transform: "translate(0 -1)",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19,9.5v-4A4.51,4.51,0,0,0,14.5,1H4.5A4.51,4.51,0,0,0,0,5.5v4A4.51,4.51,0,0,0,4.5,14H5v3.5a.5.5,0,0,0,.85.35L9.71,14H14.5A4.51,4.51,0,0,0,19,9.5Z",
    transform: "translate(0 -1)",
    fill: "#024965"
  }));
};

exports["default"] = _default;